import { render, staticRenderFns } from "./disabledShop.vue?vue&type=template&id=09236a73&scoped=true"
import script from "./disabledShop.vue?vue&type=script&lang=js"
export * from "./disabledShop.vue?vue&type=script&lang=js"
import style0 from "./disabledShop.vue?vue&type=style&index=0&id=09236a73&prod&lang=scss"
import style1 from "./disabledShop.vue?vue&type=style&index=1&id=09236a73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09236a73",
  null
  
)

export default component.exports